export default __webpack_public_path__ + "static/google-map-results-f66c36654bb2e2c90086e43ec551c1dd.jpg";